import { useEffect } from 'react';
import { trackEvent } from '../../utils/tracking';
import StickyNav from './components/StickyNav';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import CategoryGrid from './components/CategoryGrid';
import TopCategoriesSection from './components/TopCategoriesSection';
import TodayOpportunitiesSection from './components/TodayOpportunitiesSection';
import PersonalizedSection from './components/PersonalizedSection';
import BottomSection from './components/BottomSection';
import FloatingWhatsApp from './components/FloatingWhatsApp';

export default function Home() {
  useEffect(() => {
    trackEvent('page_view', { page: 'home' });
  }, []);

  return (
    <div className="bg-[#0a0a0f] min-h-screen">
      <StickyNav />
      <HeroSection />
      <TrustSection />
      <CategoryGrid />
      <TopCategoriesSection />
      <TodayOpportunitiesSection />
      <PersonalizedSection />
      <BottomSection />
      <FloatingWhatsApp />
    </div>
  );
}
